import { AppState } from "fabrix/redux/store";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Supplies the user's role list along with a helper to test for role membership.
 * @returns Tuple containing the user roles array and a predicate for required roles.
 */
export function useHasRoles() {

    const roles = useSelector((state: AppState) => state.currentUser.roles);
    const _userRoles = useMemo<string[]>(() => {
        return (roles as unknown[]).reduce<string[]>((normalizedRoles, role) => {
            if (typeof role === "string") {
                normalizedRoles.push(role);
            } else if (role && typeof role === "object" && "key" in role) {
                const key = (role as { key?: unknown }).key;
                if (typeof key === "string") {
                    normalizedRoles.push(key);
                }
            }
            return normalizedRoles;
        }, []);
    }, [roles]);
    const userRoleSet = useMemo(() => new Set(_userRoles), [_userRoles]);

    const hasRole = useCallback((requiredRoles: string[]) => {
        return requiredRoles.length === 0 || requiredRoles.some((role) => userRoleSet.has(role));
    }, [userRoleSet]);


    return [_userRoles, hasRole] as const;

}
